import type { IRogue } from '@/js/services/RogueTypes'

/**
 * Alt text for a customer review photo. Bazaarvoice captions are optional, so fall back to the
 * reviewer's name and then a generic label; the alt attribute must never be empty or omitted.
 */
export function reviewPhotoAlt(rogue: Pick<IRogue, '__'>, caption?: string | null, authorName?: string | null): string {
  const text = caption?.trim()
  if (text) {
    return text
  }

  const author = authorName?.trim()
  if (author) {
    return rogue.__('Customer photo from {author}\'s review', { author })
  }

  return rogue.__('Customer photo')
}
